import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Path, Rect } from 'react-native-svg'
import { useResponsive } from '@/screens/new-design/hooks'

interface PlaySVGProps {
  bgFill?: string
  iconFill?: string
}

/** Play (resume) icon only – 40x40, no text. Use in compact controls e.g. teacher bottom bar. */
export const PlaySVG = ({
  bgFill = Palette['Shades/Maroon 2'],
  iconFill = Palette['Brand/Cream'],
  ...rest
}: React.ComponentProps<typeof Svg> & PlaySVGProps) => {
  const { verticalScale } = useResponsive()

  return (
    <Svg width={verticalScale(40)} height={verticalScale(40)} viewBox="0 0 40 40" fill="none" {...rest}>
      <Rect width={40} height={40} rx={20} fill={bgFill} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12v16l12-8-12-8z"
        fill={iconFill}
      />
    </Svg>
  )
}
